// Module
var code = "<template> <slot></slot> </template> ";
// Exports
export default code;